// External dependencies.
import $ from "jquery";

/**
 * CouponFormal class.
 *
 * @since 1.5.2
 * @class CouponFormModal
 */
class CouponFormModal {
    /**
     * Creates an instance of CouponFormModal.
     * 
     * @since 1.5.2
     * @memberof CouponFormModal
     */
    constructor() {
        this.modalInterval = null;
        this.modalElement = document.querySelector( '#ts-coupon-form-modal' );
        this.events = this.events.bind( this );
        this.handleModal = this.handleModal.bind( this );
        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 1.5.2
     * @listens event:load
     * @listens #ts-coupon-form-modal~event:hidden.bs.modal
     * @memberof CouponFormModal
     */
    events() {
        window.addEventListener( 'load', this.handleModal );
        $( this.modalElement ).on( 'hidden.bs.modal', () => window.sessionStorage.setItem( 'modalHasBeenClosed', 1 ) );
    }

    /**
     * Handles the modal display functionality.
     *
     * @since 1.5.2
     * @returns
     * @memberof CouponFormModal
     */
    handleModal() {
        const modalHasBeenClosed = window.sessionStorage.getItem( 'modalHasBeenClosed' );

        if ( '1' === modalHasBeenClosed ) {
            return;
        }

        const { coupon_form_modal_timeout } = window.app;
        const timeout = parseInt( coupon_form_modal_timeout );
        let timeElapsed = parseInt( window.sessionStorage.getItem( 'modalTimeElapsed' ) ) || 0;

        this.modalInterval = setInterval( () => {
            timeElapsed += 1;

            if ( 0 >= timeout - ( timeElapsed * 1000 ) ) {
                clearInterval( this.modalInterval );
                $( this.modalElement ).modal();
                window.sessionStorage.removeItem( 'modalTimeElapsed' );
                return;
            }

            window.sessionStorage.setItem( 'modalTimeElapsed', timeElapsed );
        }, 1000 );
    }
}

export default CouponFormModal;
